import React from 'react';
import {Button, Modal, ModalBody, ModalHeader} from 'reactstrap';
import {UsersEndpoints} from "../../common/ProxyEndpoints";
import HTML from '../../common/HtmlHelpers';
import TTLProxy from "../../common/TTLAsyncProxy";
import FormRenderer from "../../common/FormRenderer/FormRenderer";
import DialogCollapseSection from "../DialogCollapseSection/DialogCollapseSection";
import MDProgress from 'react-md-progress-bar';

const ErrorHint = (props) => {
    return props.error && <p className="error-label" style={{marginTop: '4px'}}>{props.err}</p>
};

class CreateAdminAccount extends React.Component {

    inputs  = [
        {
            group: [
                { name: "username" , title: "Username" , hint: "Enter account username... eg Kofi350" , icon: "fa fa-user" , type: "text" , required: true },
                { name: "password" , title: "Password" , hint: "Enter account password. Default [username]@trotrotractor" , icon: "fa fa-lock" , type: "password" },
                { name: "phone"  , title: "Phone No.", hint: "Enter phone number here... eg 0203334532" , icon: "fa fa-phone" , type: "phone" , required: true },
                { name: "email"  , title: "Email", hint: "Enter email here..." , icon: "fa fa-mail" , type: "email" , required: true }
            ],
            render: (content,key) => {
                return <DialogCollapseSection initiallyOpen={true} title={"Account Info"} key={key}>
                    {content}
                </DialogCollapseSection>
            }
        },
        {
            group:[
                { name: "name" , title: "Full Name" , hint: "Enter your full name here... eg Caree Postman" , icon: "fa fa-user" , type: "text" , required: true },
            ],
            render: (content,key) => {
                return <DialogCollapseSection initiallyOpen={true} title={"Personal Details"} key={key}>
                    {content}
                </DialogCollapseSection>
            }
        }
    ];

    constructor(props){
        super(props);

        this.state = {
            isBusy: false
        };

        //  toggle dialog
        this.onToggle = this.toggle.bind(this);

        //  get proxy reference
        this.proxy = TTLProxy.getInstance();
    }

    toggle(){
        this.setState({
            isOpen : !this.state.isOpen
        });
    }

    /**
     * Shows the dialog
     */
    show(){

        this.setState({
            isOpen: true
        });
    }

    onCreateAccount(formData){

        const me = this;
        const form = this._form;

        this.setState({
            isBusy: true
        });

        return this.proxy.processRequest(UsersEndpoints.registerUserAccount('admin',false, false , {

            username: formData.username,
            password: formData.password || `${formData.username}@trotrotractor`,
            email: formData.email,
            phone: formData.phone,
            admin:{
                name: formData.name
            }

        })).then((response) => {

            //  account created now
            if(response.ok){

                me.setState({
                    isBusy: false
                });

                HTML.toastMessage('Administrator created successfully!');
            }
            else{

                me.setState({
                    isBusy: false,
                    errorMessage: "Failed: Something wen't wrong. Please try again!"
                });
            }

            //  toggle dialog visibility
            me.toggle();

        }).catch((err) =>{

            //  update exception
            form.updateException(err);

            //  clear busy state
            me.setState({ isBusy: false });

        });

    }

    renderForm(){

        return <FormRenderer busy={this.state.isBusy}
                             inputs={this.inputs}
                             onSubmit={this.onCreateAccount.bind(this)}
                             ref={f => this._form = f}>
            <hr/>
            {this.state.isBusy && <MDProgress show={this.state.isBusy} overlay={true}/>}
            <Button type="submit" color="green" disabled={this.state.isBusy} block><i className="fa fa-plus"></i> Create Admin</Button>
        </FormRenderer>
    }

    render(){
        return (<Modal toggle={this.onToggle} fade={true} isOpen={this.state.isOpen}>
                <ModalHeader toggle={this.onToggle}>Register Administrator</ModalHeader>
                    <ModalBody>
                         {this.renderForm()}
                    </ModalBody>

                </Modal>);
    }


}


export default CreateAdminAccount;



// WEBPACK FOOTER //
// ./src/components/CreateAdminAccount/CreateAdminAccount.js